import { io } from "socket.io-client";
import { checkFileExists } from "@/utils/apiFunctions.js";
import { mapGetters } from "vuex";

export default {
	computed: {
		...mapGetters("userVUEX", {
			licenseKey: "getlicenseKey",
		}),
	},

	methods: {
		async uploadFileViaSocket(file, fileMeta) {
			//  build bucketPath
			const timestamp = Date.now();
			const bucketPath = `${this.licenseKey}/questionsMedia/${timestamp}/${file.name}`;

			// check file exists / get upload info
			const res = await checkFileExists({
				fileName: file.name,
				content: fileMeta.content,
				size: file.size,
				bucket: "cvquestionmedia",
				bucketPath,
			});

			if (res.status !== 200) {
				throw new Error("checkFileExists failed");
			}

			const uploadData = res.data.data;

			//  read file buffer
			const arrayBuffer = await file.arrayBuffer();

			//chunk file
			const CHUNK_SIZE = 5 * 1024 * 1024;
			const chunks = [];
			let offset = 0;

			while (offset < arrayBuffer.byteLength) {
				chunks.push(arrayBuffer.slice(offset, offset + CHUNK_SIZE));
				offset += CHUNK_SIZE;
			}

			// socket connection
			const socket = io("https://awsmultipart.hire3x.com/", {
				transports: ["websocket"],
				withCredentials: true,
			});

			return new Promise((resolve, reject) => {
				const {
					_id,
					totalChunks,
					fileSize,
					uploadId,
					bucket,
					bucketPath,
				} = uploadData;

				socket.on("connect", () => {
					// send first chunk
					socket.emit(
						"store-chunk",
						chunks.shift(),
						_id,
						uploadData.uploadedChunks,
						totalChunks,
						fileSize,
						uploadId,
						bucket,
						bucketPath,
						true
					);

					socket.on("send-chunk", (_, uploadedChunksCount) => {
						// CALCULATE PROGRESS
						const percent = Math.round(
							(uploadedChunksCount / totalChunks) * 100
						);

						// EMIT TO COMPONENT (Vue 2 safe)
						this.progress = percent;
						if (chunks.length > 0) {
							socket.emit(
								"store-chunk",
								chunks.shift(),
								_id,
								uploadedChunksCount,
								totalChunks,
								fileSize,
								uploadId,
								bucket,
								bucketPath,
								true
							);
						}
					});

					socket.on("upload-complete", () => {
						this.progress = 100;
						this.showSpinner = false;
						socket.disconnect();
						resolve(bucketPath);
					});

					socket.on("upload-failed", () => {
						socket.disconnect();
						this.showSpinner = false;
						reject(new Error("Upload failed"));
					});
				});
			});
		},
	},
};
